var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LayoutTitle',{attrs:{"title":"Merchant Lead","description":"View All Detail"}}),_c('Tab',{staticStyle:{"margin-bottom":"-50px","margin-top":"50px"},attrs:{"tabs":_vm.tabs}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }